import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { Modal, Typography, Divider } from "antd";
import TransferCompare from "./transferCompare";
import { gql, useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import CompareChartNew from "./compareChartNew";
import RangePickerAnalyse from "./RangePicker";
import Loader from "../../Loader";

const { Text, Paragraph } = Typography;

const GET_PO_GROUPS = gql`
  query Groups($plant_id: Int!,$date_time: Date,$offset_date: Int) {
    GetOptimizers(plant_id: $plant_id,date_time:$date_time,offset_date:$offset_date) {
      Opt_Group_id
      optimizers {
        PO_id
        serial_number
        production {
          Vpv
          Ipv
          Vbat
          Ibat
          Temp
          SOC
        }
      }
    }
  }
`;

const date = new Date()
const offset_date = (new Date()).getTimezoneOffset()

const ComparePanels = () => {
  const plant_id = useSelector((state) => state.plant_id);
  const lang_choiced = useSelector((state) => state.lang_change);

  const [PO_groups, setPO_groups] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [keys, setKeys] = useState([]);
  const [showItem, setShowItem] = useState([]);
  const [modal, setModal] = useState(false);
  const [dateHOC, setDateHOC] = useState([
    new Date(),
    new Date()
  ]);

  const targetKeys = (props, checkedKeys, showItem) => {
    setKeys(checkedKeys);
    setChartData(props.data);
    setShowItem(showItem);
  };

  const { loading } = useQuery(GET_PO_GROUPS, {
    variables: { plant_id: parseInt(plant_id),date_time:date,offset_date },
    onCompleted: (res) => {
      // console.log(res.GetOptimizers , "is GetOptimizers");
      setPO_groups(res.GetOptimizers);
    },
    // pollInterval:60000
  });
  // console.log(chartData, "is chart data");
  if (loading === true) {
    return (
      <div className="animated fadeIn">
        <Loader />
      </div>
    );
  } else {
    return (
      <div className="animated fadeIn">
        <div>
          <Card className="border-radius-15 compare-chart-card">
            <CardHeader>
              <h4>{lang_choiced.pages.compare_panel.title}</h4>
            </CardHeader>
            <CardBody>
              <Row className="ml-2 mr-2">
                <Paragraph>
                  <Text type="success">
                    {lang_choiced.pages.compare_panel.tip}
                  </Text>
                  <Text>{lang_choiced.pages.compare_panel.tipText}</Text>
                </Paragraph>
              </Row>

              <Button color="info" onClick={() => setModal(true)}>
                {lang_choiced.pages.compare_panel.btnSelectParameters}
              </Button>
              <Divider />
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  style={{ overflowX: "auto", overflowY: "hidden" }}
                >
                  <CompareChartNew
                    data={chartData}
                    targetKeys={keys}
                    showItem={showItem}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Modal open={modal} footer={null} onCancel={() => setModal(false)}>
            <ModalHeader>{lang_choiced.pages.compare_panel.modal.title}</ModalHeader>
            <ModalBody>
              <div>
                <TransferCompare
                  PO_groups={PO_groups}
                  targetKeys={targetKeys}
                  dateHOC={dateHOC}
                  setModal={(bool) => setModal(bool)}
                  // setDateHOC={(e) => setDateHOC(e)}
                >
                  <div className="text-center">
                    <RangePickerAnalyse
                      dateHOC={dateHOC}
                      setDateHOC={(date) => {
                        setChartData([]);
                        setDateHOC(date);
                      }}
                    />
                  </div>
                </TransferCompare>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </div>
    );
  }
};

export default ComparePanels;
